import { Loading } from '@rrexpress/core';
import { CSSProperties, PropsWithChildren } from 'react';
import { classJoin } from '@/utility/helper/classJoin';

export type LoadingOverlayProps = {
  isLoading: boolean,
  className?: string,
  paddingTop?: CSSProperties['paddingTop'],
  variant?: 'line' | 'circular',
  size?: number,
};

export function LoadingOverlay({
  children,
  className,
  isLoading,
  paddingTop,
  size,
  variant,
}: PropsWithChildren<LoadingOverlayProps>) {
  return (
    <div className={classJoin('relative', className)}>
      {isLoading && (
        <div
          className="absolute inset-0 z-10 bg-white bg-opacity-80 rounded-xl overflow-hidden"
          style={{
            paddingTop: paddingTop ?? 64,
          }}
        >
          <Loading
            variant={variant ?? 'circular'}
            size={size ?? 64}
            speed={0.6}
            indicatorCap="round"
          />
        </div>
      )}
      {children}
    </div>
  );
}
